import { gql } from '@apollo/client';

export const CHECK_DISTRICT_OFFICE = gql`
  mutation checkDistrictOffice($input: CheckDistrictOfficeInput!) {
    checkDistrictOffice: checkDistrictOfficeInstitutionBeforeUpserting(input: $input) {
      exists
      message
    }
  }
`;
